module.exports = __webpack_public_path__ + "static/media/foto14.0e89ab25.jpg";